export const SIGN_IN_METHOD_EMAIL = "email";
export const SIGN_IN_METHOD_GOOGLE = "google";

export const MERCHANT_USERTYPE = "merchant";
export const FEDERAL_WORKER_USERTYPE = "worker";
export const NONE_FEDERAL_WORKER_USERTYPE = "user";

export const PAYMENT_OPTION_PAY_IN_FULL = "pay-in-full";
export const PAYMENT_OPTION_BNPL = "bnpl";
export const PAYMENT_OPTION_HYBRID = "hybrid";
export const CHECKOUT_PAYMENT_OPTIONS = [PAYMENT_OPTION_PAY_IN_FULL, PAYMENT_OPTION_BNPL, PAYMENT_OPTION_HYBRID];

export const USER_ORDERS_QUERY_KEY = "user-orders";

export const CART_QUERY_KEY = "cart";
export const CART_ITEMS_QUERY_KEY = "cart-items";
export const CART_MERGE_QUERY_KEY = "cart-merge";

export const CUSTOMER_USER_ROLE = "customer";
export const SALES_AGENT_USER_ROLE = "sales_agent";
